var map = {
	"./abstract.svg": 27646,
	"./apechain.svg": 17731,
	"./aptos.svg": 22767,
	"./arb.svg": 77653,
	"./aurora.svg": 55552,
	"./avax.svg": 20198,
	"./base.svg": 18803,
	"./berachain.svg": 67895,
	"./blast.webp": 93051,
	"./bnb.svg": 49830,
	"./boba.svg": 44462,
	"./bsv.svg": 52613,
	"./btc.svg": 86969,
	"./cardano.svg": 24010,
	"./celo.webp": 70398,
	"./chiliz.svg": 21763,
	"./core.webp": 7000,
	"./cronos.svg": 13278,
	"./dot.svg": 71249,
	"./eth.svg": 42285,
	"./etherlink.svg": 78148,
	"./fantom.svg": 45645,
	"./flare.svg": 10848,
	"./fraxtal.svg": 29082,
	"./glmr.svg": 13956,
	"./gnosis.svg": 46033,
	"./harmony.svg": 91294,
	"./hyperevm.svg": 20040,
	"./immutable-zkevm.svg": 37874,
	"./ink.svg": 95288,
	"./kaia.svg": 6678,
	"./kava.svg": 87287,
	"./linea.svg": 52055,
	"./lisk.svg": 79123,
	"./ltc.svg": 31623,
	"./manta-pacific.svg": 75587,
	"./mantle.webp": 73640,
	"./metis.svg": 59746,
	"./mode.webp": 20852,
	"./moonriver.svg": 54467,
	"./morph.webp": 20247,
	"./opbnb.webp": 26758,
	"./optimism.svg": 69530,
	"./plume.svg": 22299,
	"./polygon-zkevm.svg": 26756,
	"./polygon.svg": 45742,
	"./pulsechain.svg": 57178,
	"./ronin.svg": 70464,
	"./rootstock.svg": 5822,
	"./scroll.svg": 57183,
	"./sei.svg": 77729,
	"./sol.svg": 17754,
	"./soneium.svg": 6656,
	"./sonic.svg": 70752,
	"./story.webp": 39200,
	"./swellchain.svg": 96222,
	"./taiko.svg": 55496,
	"./tanssi.svg": 61364,
	"./telos.svg": 35033,
	"./tempo.svg": 65789,
	"./ton.svg": 42475,
	"./tron.svg": 70293,
	"./unichain.svg": 2429,
	"./worldchain.svg": 54555,
	"./worldcoin.svg": 34351,
	"./xrp.svg": 47658,
	"./zircuit.svg": 14404,
	"./zksync.svg": 8028,
	"./zora.svg": 38102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64788;